import Layout from "../components/Layout";
import { proSeriesMeta } from "../data/DataMetatags";
import { defBreadcrumb } from "../data/DataBreadcrumb";
import NextHead from "../components/Seo/NextHead";
import BreadcrumbComponent from "../components/UserInterface/BreadcrumbComponent";
import { ProSeriesBreadcrumb } from "../data/DataBreadcrumb";
import { ImageComponent } from "../components/UserInterface/ImageComponent";
import Images from "../components/UserInterface/Images";
import tecProtecImg from "../../public/static/images/svg/logo-tecprotec.svg";
import HeadingComponent from "../components/UserInterface/HeadingComponent";
import Description from "../components/UserInterface/Description";
import { NumberedText } from "../components/UserInterface/NumberedText";
import {
  KlaimProSERIES,
  BenefitProSERIES,
  TableProSERIES
} from "../data/DataProSERIES";
import LayoutCenter from "../components/UserInterface/LayoutCenter";
import proSERIESImg from "../../public/static/images/png/Claim-proseries.png";
import { SEOText } from "../components/UserInterface/SEOText";
import { ProSERIESSEO } from "../data/DataSEO";
import { TableComponent } from "../components/UserInterface/TableComponent";

const AsuransiBarangElektronik = (props) => {
  const {
    breadcrumb,
    title,
    description,
    path,
    ProSeriesBreadcrumb,
    BenefitProSERIES,
    TableProSERIES,
    KlaimProSERIES,
    ProSERIESSEO
  } = props;

  return (
    <Layout>
      <NextHead
        title={title}
        description={description}
        url={path}
        breadcrumb={breadcrumb}
      />
      <BreadcrumbComponent items={ProSeriesBreadcrumb} />
      <ImageComponent url={tecProtecImg} />
      <HeadingComponent headingText="proSERIES" />
      <Description
        width="820px"
        margin="12px 16px"
        font="Roboto"
        text="Lindungi Handphone, Tablet dan Laptop kamu dari kerusakan yang tidak disengaja dengan proSERIES!"
      />
      <Description
        width="820px"
        margin="12px 16px"
        font="Roboto"
        text="proSERIES adalah produk proteksi yang memberikan perlindungan untuk handphone, tablet atau laptop kamu dari kerusakan fisik ataupun kerusakan akibat cairan yang tidak disengaja. Layanan proSERIES akan memberikan perlindungan tambahan diluar garansi pabrikan yang pada umumnya meliputi kerusakan mekanis yang timbul akibat kesalahan pabrik."
      />
      <Description
        width="820px"
        margin="12px 16px"
        font="Roboto"
        text="proSERIES hanya tersedia untuk produk ERAJAYA (Erafone, Oppo, NASA, PPP Indosat, iBox, Mi Store), Telesindo/Megafon, dan Cantik/Dering."
      />
      <LayoutCenter mobileDirection>
        <Images width="460px" url={proSERIESImg} />
        <NumberedText
          title="Manfaat proSERIES"
          withoutNumber
          data={BenefitProSERIES}
        />
      </LayoutCenter>
      <LayoutCenter column>
        <HeadingComponent headingText="Resiko yang di Tanggung" />
        <TableComponent
          table={TableProSERIES}
          width1="64px"
          width2="64px"
          mobileWidth1="30px"
          mobileWidth2="30px"
        />
      </LayoutCenter>
      <LayoutCenter column>
        <HeadingComponent headingText="Cara klaim proSERIES" />
        <NumberedText data={KlaimProSERIES} />
      </LayoutCenter>
      <HeadingComponent
        fontWeight="bold"
        headingText="Penyedia Jasa proSERIES®"
      />
      <Description
        margin="16px"
        font="Roboto"
        text="proSERIES® merupakan produk kolaborasi antara PT Home Credit Indonesia dengan PT Bolttech Device Protection Indonesia (bolttech).<br> PT Home Credit Indonesia berizin dan diawasi oleh Otoritas Jasa Keuangan (OJK)."
      />
      <SEOText title={ProSERIESSEO.title} text={ProSERIESSEO.text} />
    </Layout>
  );
};

export const getStaticProps = async () => {
  const { title, description, path } = proSeriesMeta;

  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseUrl + path,
        name: title
      }
    }
  ];

  return {
    props: {
      breadcrumb,
      title,
      description,
      path,
      ProSeriesBreadcrumb,
      BenefitProSERIES,
      TableProSERIES,
      KlaimProSERIES,
      ProSERIESSEO
    }
  };
};

export default AsuransiBarangElektronik;
